import { api } from "@shared/api/client";
import type { CalidadControlModificacion, CalidadControlModificacionPayload } from "../../../types/control-modificaciones";
import type {
  CalidadDafoAnalisis,
  CalidadDafoAnalisisPayload,
  CalidadDafoParteInteresada,
  CalidadDafoParteInteresadaPayload,
  DafoFilters,
  DafoPlantillaAnualPayload,
  DafoResponse,
} from "../types/dafo";

function buildParams(filters: DafoFilters) {
  return {
    anio: filters.anio || undefined,
    search: filters.search || undefined,
    parte_interesada: filters.parte_interesada || undefined,
  };
}

export async function getCalidadDafo(filters: DafoFilters, signal?: AbortSignal) {
  const { data } = await api.get<DafoResponse>("/certificaciones/iso-9001-14001/dafo", {
    params: buildParams(filters),
    signal,
  });
  return data;
}

export async function createCalidadDafoAnalisis(payload: CalidadDafoAnalisisPayload) {
  const { data } = await api.post<{ ok: boolean; data: CalidadDafoAnalisis }>("/certificaciones/iso-9001-14001/dafo/analisis", payload);
  return data.data;
}

export async function updateCalidadDafoAnalisis(id: number, payload: CalidadDafoAnalisisPayload) {
  const { data } = await api.put<{ ok: boolean; data: CalidadDafoAnalisis }>(`/certificaciones/iso-9001-14001/dafo/analisis/${id}`, payload);
  return data.data;
}

export async function deleteCalidadDafoAnalisis(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/dafo/analisis/${id}`);
}

export async function createCalidadDafoParteInteresada(payload: CalidadDafoParteInteresadaPayload) {
  const { data } = await api.post<{ ok: boolean; data: CalidadDafoParteInteresada }>("/certificaciones/iso-9001-14001/dafo/partes-interesadas", payload);
  return data.data;
}

export async function updateCalidadDafoParteInteresada(id: number, payload: CalidadDafoParteInteresadaPayload) {
  const { data } = await api.put<{ ok: boolean; data: CalidadDafoParteInteresada }>(`/certificaciones/iso-9001-14001/dafo/partes-interesadas/${id}`, payload);
  return data.data;
}

export async function deleteCalidadDafoParteInteresada(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/dafo/partes-interesadas/${id}`);
}

export async function deleteCalidadDafoYear(anio: number) {
  const { data } = await api.delete<{ ok: boolean; analisis_eliminados: number; partes_interesadas_eliminadas: number }>(`/certificaciones/iso-9001-14001/dafo/anios/${anio}`);
  return data;
}

export async function crearCalidadDafoPlantillaAnual(payload: DafoPlantillaAnualPayload) {
  const { data } = await api.post<{ ok: boolean; analisis_copiados: number; partes_interesadas_copiadas: number }>(
    "/certificaciones/iso-9001-14001/dafo/crear-plantilla-anual",
    payload,
  );
  return data;
}

export async function createDafoControlModificacion(payload: CalidadControlModificacionPayload) {
  const { data } = await api.post<{ ok: boolean; data: CalidadControlModificacion }>(
    "/certificaciones/iso-9001-14001/dafo/control-modificaciones",
    payload,
  );
  return data.data;
}

export async function updateDafoControlModificacion(id: number, payload: CalidadControlModificacionPayload) {
  const { data } = await api.put<{ ok: boolean; data: CalidadControlModificacion }>(
    `/certificaciones/iso-9001-14001/dafo/control-modificaciones/${id}`,
    payload,
  );
  return data.data;
}

export async function deleteDafoControlModificacion(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/dafo/control-modificaciones/${id}`);
}
